var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(190, 33, 38)",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.449,228.343l-14.689,3.922c-31.173,8.322-64.692-0.661-87.475-23.444l-0.01,0.01l-63.282-63.281l-10.761-10.761 L113.748,297.275l-21.52,21.52L0,411.023l88.659,88.659l63.533-120.921l24.838,24.838l36.289-36.289l30.895,74.587l73.375-30.394 l-24.224-58.481l43.569-43.569c10.167,4.783,20.775,8.647,31.711,11.473c30.37,7.845,62.438,7.716,92.742-0.373l14.717-3.929 L452.449,228.343z M191.412,325.932l-21.52-21.52l91.957-91.957l21.52,21.52L191.412,325.932z M280.758,322.587l-6.654-16.064 l22.79-22.79c4.132,3.494,8.403,6.803,12.813,9.905L280.758,322.587z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "490.48,14.354 473.147,31.687 453.779,12.318 432.259,33.839 451.627,53.207 392.094,112.74 357.455,78.099  310.019,125.536 366.178,181.696 402.855,145.021 413.615,134.26 512,35.875  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttack);
export default __webpack_public_path__ + "static/media/attack.1fbe8414fac9aefc41c5f0bc3ee741e8.svg";
export { ForwardRef as ReactComponent };